import {Exclude, Expose, instanceToPlain, plainToInstance} from "class-transformer";
import * as t from "io-ts";
import {validateJSON, validateJSONNow} from "../web/validation";

export const AllocatableLoadInventorySnapshotEntryValidator = t.intersection([
    t.type({
        dttm: t.number,
        count: t.number,
        volume: t.number,
    }),
    t.partial({}),
]);

export const AllocatableLoadInventorySnapshotEntryArrayValidator = t.array(AllocatableLoadInventorySnapshotEntryValidator);

export type AllocatableLoadInventorySnapshotEntrySnapshotEntry = t.TypeOf<typeof AllocatableLoadInventorySnapshotEntryValidator>;
export type AllocatableLoadInventorySnapshotEntryArray = t.TypeOf<typeof AllocatableLoadInventorySnapshotEntryArrayValidator>;

@Exclude()
export class AllocatableLoadInventorySnapshotEntryEntity {
    @Expose()
    dttm!: number

    @Expose()
    count!: number

    @Expose()
    volume!: number

    /**
     * Constructor for AllocatableLoadInventorySnapshotEntryEntity.
     * @hideconstructor
     */
    constructor() {
        // Empty constructor for 'class-transformer'
    }

    static from(containerAllocatableLoadInventorySnapshotEntry: AllocatableLoadInventorySnapshotEntrySnapshotEntry): AllocatableLoadInventorySnapshotEntryEntity {
        return plainToInstance(
            AllocatableLoadInventorySnapshotEntryEntity,
            containerAllocatableLoadInventorySnapshotEntry,
            {
                excludeExtraneousValues: true,
            }
        );
    }

    loadTypeValue(): Promise<AllocatableLoadInventorySnapshotEntrySnapshotEntry> {
        const object = instanceToPlain(this, {
            excludeExtraneousValues: true,
        });
        return validateJSON(AllocatableLoadInventorySnapshotEntryValidator, object);
    }

    asTypeValue(): AllocatableLoadInventorySnapshotEntrySnapshotEntry {
        const object = instanceToPlain(this, {
            excludeExtraneousValues: true,
        });
        return validateJSONNow(AllocatableLoadInventorySnapshotEntryValidator, object);
    }
}
